import graph from './graph';
import React, { useEffect, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineRounded from '@mui/icons-material/DeleteOutlineRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';

import { Card, Stack, Badge, Button, Avatar, Typography, CardHeader, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { useLazyQuery, useMutation } from '@apollo/client';
import { NewDialog, NewDialogTitle, NewDialogContent, NewDialogActions } from 'components';

export default function UserGroups({ ids, title, groups = [], refetch }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState([]);
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [deleteModel] = useMutation(graph.delete.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids,
          for_admin: 1,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { categories } = res;
        if (res) {
          setFormData(categories);
        }
      }
    } catch (error) {}
  };

  const onDelete = async (category_ids) => {
    try {
      const { data, errors } = await deleteModel({
        context: {
          serviceName: graph.delete.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: { user_ids: ids, category_ids },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.delete.name]?.messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Tooltip title={title}>
        <Badge
          color="primary"
          variant="dot"
          overlap="circular"
          invisible={!groups.length}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <IconButton
            size="small"
            color="primary"
            onClick={onOpen}
            disabled={!groups.length}
            sx={{ bgcolor: 'action.hover' }}
          >
            <GroupsRoundedIcon fontSize="small" />
          </IconButton>
        </Badge>
      </Tooltip>
      <NewDialog label="create" open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack rowGap={2} height="100%" alignItems="center" justifyContent="center">
                <CircularProgress size={20} color="inherit" />
                <Typography align="center" variant="caption" color="text.disabled">
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <Stack rowGap={1}>
                {formData.map((item, i) => {
                  const { id, title, lab, unit } = item;
                  return (
                    <Card key={i} sx={{ width: '100%' }}>
                      <CardHeader
                        title={title}
                        subheader={lab?.title || unit?.title}
                        avatar={
                          <Avatar sx={{ bgcolor: 'action.hover' }}>
                            <GroupsRoundedIcon color="primary" />
                          </Avatar>
                        }
                        action={
                          <IconButton color="error" onClick={() => onDelete(id)}>
                            <DeleteOutlineRounded fontSize="small" />
                          </IconButton>
                        }
                      />
                    </Card>
                  );
                })}
              </Stack>
            )}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            color="primary"
            variant="contained"
            onClick={onClose}
            sx={{ minWidth: 80 }}
            disabled={loading}
          >
            <FormattedMessage id="close" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
